import { useTranslation } from 'react-i18next';
import { Statistic, Task } from '@repo/shared';
import { useRouter } from '@tanstack/react-router';
import { Rocket } from 'lucide-react';

export function useConfig() {
  const { t } = useTranslation();
  const router = useRouter();
  return {
    name: 'Crius',
    logo: <Rocket className='h-8 w-8 p-2' />,
    mainNav: [
      {
        title: t('navigation.tasks.title'),
        href: router.buildLocation({
          to: '/app/tasks',
        }),
        items: [
          {
            title: t('navigation.tasks.extractStructure.title'),
            description: t('navigation.tasks.extractStructure.description'),
            href: router.buildLocation({
              to: '/app/tasks/$task',
              params: {
                task: Task.EXTRACT_STRUCTURE,
              },
            }),
          },
          {
            title: t('navigation.tasks.describeImage.title'),
            description: t('navigation.tasks.describeImage.description'),
            href: router.buildLocation({
              to: '/app/tasks/$task',
              params: {
                task: Task.DESCRIBE_IMAGE,
              },
            }),
          },
          {
            title: t('navigation.tasks.textTranslation.title'),
            description: t('navigation.tasks.textTranslation.description'),
            href: router.buildLocation({
              to: '/app/tasks/$task',
              params: {
                task: Task.TEXT_TRANSLATION,
              },
            }),
          },
          {
            title: t('navigation.tasks.generateAudio.title'),
            description: t('navigation.tasks.generateAudio.description'),
            href: router.buildLocation({
              to: '/app/tasks/$task',
              params: {
                task: Task.GENERATE_AUDIO,
              },
            }),
          },
        ],
      },
      {
        title: t('navigation.datasets.title'),
        href: router.buildLocation({
          to: '/app/datasets',
          search: {
            isEval: true,
          },
        }),
        items: [
          {
            title: t('navigation.datasets.manage.title'),
            description: t('navigation.datasets.manage.description'),
            href: router.buildLocation({
              to: '/app/datasets',
              search: {
                isEval: true,
              },
            }),
          },
        ],
      },
      {
        title: t('navigation.evaluations.title'),
        href: router.buildLocation({
          to: '/app/clusters',
          search: {
            isEval: true,
          },
        }),
        items: [
          {
            title: t('navigation.evaluations.clusters.title'),
            description: t('navigation.evaluations.clusters.description'),
            href: router.buildLocation({
              to: '/app/clusters',
              search: {
                isEval: true,
              },
            }),
          },

          {
            title: t('navigation.evaluations.leaderboards.title'),
            description: t('navigation.evaluations.leaderboards.description'),
            href: router.buildLocation({
              to: '/app/leaderboards',
              search: {
                datasetIds: [],
              },
            }),
          },
        ],
      },
      // https://coderfaction.atlassian.net/browse/CRIUS-263
      // {
      //   title: t('navigation.playground.title'),
      //   href: router.buildLocation({
      //     to: '/app/playground',
      //   }),
      //   items: [
      //     {
      //       title: t('navigation.playground.textTranslation.title'),
      //       description: t('navigation.playground.textTranslation.description'),
      //       href: router.buildLocation({
      //         to: '/app/playground/$task',
      //         params: {
      //           task: Task.TEXT_TRANSLATION,
      //         },
      //       }),
      //     },
      //   ],
      // },
      {
        title: t('navigation.statistics.title'),
        href: router.buildLocation({
          to: '/app/statistics/$statistic',
          params: {
            statistic: Statistic.TEST_ENVIRONMENT,
          },
        }),
        items: [
          {
            title: t('navigation.statistics.testEnvironment.title'),
            description: t('navigation.statistics.testEnvironment.description'),
            href: router.buildLocation({
              to: '/app/statistics/$statistic',
              params: {
                statistic: Statistic.TEST_ENVIRONMENT,
              },
            }),
          },
        ],
      },
    ],
  };
}
